export default function () {
  const initialState = {
    isLoading: true,
    isRefreshing: false,
    messageQueue: null
  };

  return initialState
}
